<template>
  <div>
    <el-dialog
      title="付费明细"
      center
      :visible="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="true"
      :before-close="onClose"
      width="701px"
    >
      <el-descriptions
        border
        :column="1"
        title=""
        style="width: 300px"
        size="mini"
        :labelStyle="{ width: '170px' }"
      >
        <el-descriptions-item label="常规订单总额(元)">{{
          trueOrdersPriceAmount
        }}</el-descriptions-item>
        <el-descriptions-item label="兑换码订单总额(元)">{{
          redeemCodeOrdersAmount
        }}</el-descriptions-item>
        <el-descriptions-item label="内部人员订单总额(元)">{{
          interiorOrdersPriceAmount
        }}</el-descriptions-item>
        <el-descriptions-item label="场外交易订单总额(元)">{{
          inPrivateOrdersPriceAmount
        }}</el-descriptions-item>
        <el-descriptions-item label="赠送订单总额(元)">{{
          giveOrdersPriceAmount
        }}</el-descriptions-item>
        <el-descriptions-item
          label="汇总(元)"
          :labelStyle="{ background: '#E1F3D8' }"
          >{{ totalAmount }}</el-descriptions-item
        >
      </el-descriptions>

      <el-table
        :data="orders"
        border
        size="small"
        max-height="400px"
        style="width: 681px; margin-top: 10px"
        v-el-table-infinite-scroll="loadMore"
        :infinite-scroll-disabled="orders.length == 0"
      >
        <el-table-column label="支付时间" align="center" width="120">
          <template slot-scope="scope">
            <span>{{ ms2ymdhm(scope.row.paidAt) }}</span>
          </template>
        </el-table-column>

        <el-table-column label="金额(元)" align="center" width="100">
          <template slot-scope="scope">
            <span>{{ (scope.row.amount / 100).toFixed(2) }}</span>
          </template>
        </el-table-column>

        <el-table-column
          prop="product"
          label="商品名称"
          align="center"
          width="150"
        >
        </el-table-column>

        <el-table-column prop="id" label="订单id" align="center" width="180">
        </el-table-column>
        <el-table-column label="订单类型" align="center" width="100">
          <template slot-scope="scope">
            <span>{{ getOrderTypeName(scope.row.type) }}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";
const dialogutil = require("@/dialogutil");

// 本弹窗名称
const DialogName = "OrdersInfoDialog";

export default {
  data() {
    return {
      form: {},
      orders: [],
      trueOrdersPriceAmount: 0, // 常规订单总额
      interiorOrdersPriceAmount: 0, // 内部订单总额
      inPrivateOrdersPriceAmount: 0, // 场外交易订单总额
      giveOrdersPriceAmount: 0, // 赠送订单总额
      redeemCodeOrdersAmount: 0, // 兑换码订单总额
      totalAmount: 0,
    };
  },
  components: {},

  async created() {
    this.form = dialogutil.getData(DialogName);
    await this.loadOrders(0, 10);
  },

  methods: {
    loadMore() {
      this.loadOrders(this.orders.length, 10);
    },
    /**
     * 获取玩家订单集合
     */
    async loadOrders(offset, limit) {
      if (offset == 0) {
        this.orders = [];
      }

      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/player/getPlayerPaidOrders`,
          {
            uid: this.form.uid,
            offset: offset,
            limit: limit,
          },
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message.error(resData.message);
        return;
      }

      let listInResponse = resData.data.orders || [];
      this.orders = this.orders.concat(listInResponse);

      this.trueOrdersPriceAmount = resData.data.trueOrdersPriceAmount;
      this.interiorOrdersPriceAmount = resData.data.interiorOrdersPriceAmount;
      this.inPrivateOrdersPriceAmount = resData.data.inPrivateOrdersPriceAmount;
      this.giveOrdersPriceAmount = resData.data.giveOrdersPriceAmount;
      this.redeemCodeOrdersAmount = resData.data.redeemCodeOrdersAmount;
      this.totalAmount = resData.data.totalAmount;
    },
    /**
     * 获取订单类型对应的描述
     * @param {} typ
     */
    getOrderTypeName(typ) {
      switch (typ) {
        case 0: {
          return "常规订单";
        }
        case 1: {
          return "内部人员订单";
        }
        case 2: {
          return "场外交易订单";
        }
        case 3: {
          return "赠送订单";
        }
        case 4: {
          return "兑换码订单";
        }
      }
    },
    ms2ymdhm(ts) {
      return util.ms2ymdhm(ts);
    },
    onClose(done) {
      // 关闭当前对话框
      dialogutil.close(DialogName);
    },
  },
};
</script>


<style lang="scss" scoped>
/deep/ .el-table__row td {
  padding: 3px 0;
}

/deep/ .el-table .cell {
  line-height: 18px;
}
</style>